export enum RoutesPaths {
    Home = '/',
    Login = '/login',
    PermissionDenied = '/permission-denied',
    Settings = '/settings',
}
